module.exports = __webpack_public_path__ + "static/media/muli-latin-400italic.730c6bfa.woff2";